"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const deleteShipmentCommentary_1 = __importDefault(require("./deleteShipmentCommentary"));
const getNextShipmentNumber_1 = __importDefault(require("./getNextShipmentNumber"));
const getShipmentActivity_1 = __importDefault(require("./getShipmentActivity"));
const getShipmentDuplicate_1 = __importDefault(require("./getShipmentDuplicate"));
const postShipmentCommentary_1 = __importDefault(require("./postShipmentCommentary"));
const postShipmentMatchQuery_1 = __importDefault(require("./postShipmentMatchQuery"));
const postShipmentPayment_1 = __importDefault(require("./postShipmentPayment"));
const postShipmentBoardMatchQuery_1 = __importDefault(require("./postShipmentBoardMatchQuery"));
const postShipmentWaypointDriveThrough_1 = __importDefault(require("./postShipmentWaypointDriveThrough"));
const deleteShipmentWaypointDriveThrough_1 = __importDefault(require("./deleteShipmentWaypointDriveThrough"));
const putShipmentWaypointDriveThrough_1 = __importDefault(require("./putShipmentWaypointDriveThrough"));
const putShipmentCommentary_1 = __importDefault(require("./putShipmentCommentary"));
const createShipmentClient = (axios) => ({
    deleteShipmentCommentary: ({ shipmentId, commentaryId }) => deleteShipmentCommentary_1.default({
        axios,
        shipmentId,
        commentaryId
    }),
    getNextShipmentNumber: () => getNextShipmentNumber_1.default({ axios }),
    getShipmentActivity: ({ shipmentId }) => (getShipmentActivity_1.default({ axios, shipmentId })),
    getShipmentDuplicate: ({ orderSerialNumber }) => (getShipmentDuplicate_1.default({ axios, orderSerialNumber })),
    postShipmentCommentary: ({ shipmentId, commentary }) => postShipmentCommentary_1.default({ axios, shipmentId, commentary }),
    postShipmentMatchQuery: ({ query }) => postShipmentMatchQuery_1.default({ axios, query }),
    postShipmentBoardMatchQuery: ({ query }) => postShipmentBoardMatchQuery_1.default({ axios, query }),
    postShipmentPayment: ({ shipmentId, payment }) => postShipmentPayment_1.default({ axios, shipmentId, payment }),
    postShipmentWaypointDriveThrough: ({ shipmentId, waypointId }) => postShipmentWaypointDriveThrough_1.default({
        axios,
        shipmentId,
        waypointId
    }),
    putShipmentCommentary: ({ shipmentId, commentaryId, commentary }) => putShipmentCommentary_1.default({
        axios,
        shipmentId,
        commentaryId,
        commentary
    }),
    deleteShipmentWaypointDriveThrough: ({ shipmentId, waypointId }) => deleteShipmentWaypointDriveThrough_1.default({
        axios,
        shipmentId,
        waypointId
    }),
    putShipmentWaypointDriveThrough: ({ shipmentId, waypointId, drivenThroughAt }) => putShipmentWaypointDriveThrough_1.default({
        axios,
        shipmentId,
        waypointId,
        drivenThroughAt
    })
});
exports.default = createShipmentClient;
